export const VERTICAL_LAYOUT_ANTD = "vertical";